export function getBusiness(slug) {
    return this.get(`/api/v2/business/${slug}`)
}
export function getBusinessSite(slug) {
    return this.get(`/api/business_sites/${slug}`)
}
